/**
 * Whether `pathname` is a menu's route or one of its sub-pages.
 *
 * A bare `startsWith` treats any route that merely shares a text prefix as a
 * match, so `/dashboard-v2` would resolve to the `/dashboard` menu — lighting up
 * two sidebar items and reading the wrong permission key. Requiring a `/`
 * boundary (or an exact match) keeps sibling routes distinct while every real
 * sub-page, which always adds a path segment, still matches.
 */
export const isRouteWithin = (pathname: string, route: string) =>
  pathname === route || pathname.startsWith(`${route}/`);
